import React from 'react';

const SortByAlphaIconInverted = ({ color = 'white', size = 16 }) => (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.95998 2.10654H5.81331L7.38665 0.533203L8.95998 2.10654ZM5.83331 11.9132H8.93998L7.38665 13.4665L5.83331 11.9132ZM9.66667 3.17987L6.66667 10.8199H7.89333L8.50667 9.18654H11.9133L12.5267 10.8199H13.7533L10.76 3.17987H9.66667ZM8.91333 8.0932L10.2067 4.63987L11.5 8.0932H8.91333Z" fill={color}/>
        <path d="M5.90005 9.75986H1.82005L5.77338 4.02652V3.18652H0.240046V4.25319H4.16005L0.213379 9.95986V10.8199H5.90005V9.75986Z" fill={color}/>
    </svg>
);

export default SortByAlphaIconInverted;